// extracted by css-extract-rspack-plugin
export default {"MilestoneFilterItem":"ItemPickerMilestone-module__MilestoneFilterItem__fydVvrF","MilestoneItem":"ItemPickerMilestone-module__MilestoneItem__BbdPNMO"};